import './form.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router';

import InputField from '../../shared/form-elements/input';
import SelectField from '../../shared/form-elements/select/field';
import TextField from '../../shared/form-elements/textarea';
import UploadField from '../../shared/form-elements/upload';
import LangSwitch from '../../shared/lang/switch';
import CheckboxField from '../../shared/form-elements/checkbox';

const isRocket = process.env.CPA_ENV === 'rocket';

const Form = ({
	handleSubmit,
	pristine,
	submitting,
	statusSelectOptions,
	moduleSelectOptions,
	currencySelectOptions,
	typeSelectOptions,
	categorySelectOptions,
	payoutFeeTypeOptions,
	submitForm,
	mainTabLangs,
	switchLanguage,
	editId,
	preparationFile,
	payoutSystemRegions,
	intl,
	can
}) =>
	<div className="form-container">
		<div className="form-container__head">
			<h2>
				{intl(!editId ? 'Create new payout system' : 'Edit payout system')}
			</h2>
		</div>

		<div className="form-container__body">
			<LangSwitch langs={mainTabLangs} onChangeLang={switchLanguage}/>
			<form className="ui-form create-payoutSystem" onSubmit={handleSubmit(data => submitForm(data, editId))}>
				<div className="ui-form__element images">
					<Field
						name="image"
						component={UploadField}
						placeholder={intl('Upload image')}
						preparationFile={preparationFile.bind(null, 'image')}
					/>
					{isRocket && (
						<Field
							name="image2"
							component={UploadField}
							placeholder={intl('Upload image (400×160)')}
							preparationFile={preparationFile.bind(null, 'image2')}
						/>
					)}
				</div>

				<div className="ui-form__element">
					<Field
						name="status"
						searchable={false}
						placeholder={intl('Status')}
						multi={false}
						component={SelectField}
						options={statusSelectOptions}
					/>
				</div>

				<div className="ui-form__element">
					<Field name="title" placeholder={intl('Title')} component={InputField} />
				</div>

				<div className="ui-form__element">
					<Field
						name="category"
						searchable={false}
						placeholder={intl('Category')}
						multi={false}
						component={SelectField}
						options={categorySelectOptions}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="region"
						searchable={false}
						placeholder={intl('Region')}
						multi={false}
						component={SelectField}
						options={payoutSystemRegions}
					/>
				</div>

				<div className="ui-form__element">
					<Field
						name="currency"
						searchable={false}
						placeholder={intl('Currency')}
						multi={false}
						component={SelectField}
						options={currencySelectOptions}
					/>
				</div>

				<div className="ui-form__element">
					<Field name="min_amount" placeholder={intl('Minimum payout amount')} component={InputField} />
				</div>

				<div className="ui-form__element">
					<Field name="payout_commission" placeholder={intl('Payout commission')} component={InputField} />
				</div>

				<div className="ui-form__element">
					<Field
						name="payout_commission_type"
						searchable={false}
						placeholder={intl('Payout commission type')}
						multi={false}
						component={SelectField}
						options={payoutFeeTypeOptions}
					/>
				</div>

				<div className="ui-form__element">
					<Field name="fields" placeholder={intl('Fields')} component={TextField} />
				</div>

				<div className="ui-form__element">
					<Field
						name="type"
						searchable={false}
						placeholder={intl('System type')}
						multi={false}
						component={SelectField}
						options={typeSelectOptions}
					/>
				</div>

				<div className="ui-form__element">
					<Field
						name="module"
						searchable={false}
						placeholder={intl('Automatic system module')}
						multi={false}
						component={SelectField}
						options={moduleSelectOptions}
					/>
				</div>

				<div className="ui-form__element">
					<Field name="module_options" placeholder={intl('Automatic system module options')} component={TextField} />
				</div>

				<div className="ui-form__element">
					<Field
						name="allow_floats"
						placeholder={ intl('Allow floating payout amounts') }
						component={CheckboxField} />
				</div>

				<div className="ui-form__element last-element">
					<Field
						name="is_auto_approve_enabled"
						placeholder={intl('Is auto approve enabled')}
						component={CheckboxField}
					/>
				</div>

				<div className="ui-form__element">
					{((editId && can('edit')) || (!editId && can('create'))) &&
						<button className="ui-btn ui-btn-primary">
							{intl(!editId ? 'Save' : 'Edit')}
						</button>}
					<Link to="payout-systems/">
						<button className="ui-btn ui-btn-cancel">
							{intl('Cancel')}
						</button>
					</Link>
				</div>
			</form>
		</div>
	</div>;

Form.propTypes = {
	handleSubmit: PropTypes.func,
	switchLanguage: PropTypes.func,
	pristine: PropTypes.bool,
	statusSelectOptions: PropTypes.array,
	mainTabLangs: PropTypes.array,
	moduleSelectOptions: PropTypes.array,
	currencySelectOptions: PropTypes.array,
	typeSelectOptions: PropTypes.array,
	categorySelectOptions: PropTypes.array,
	submitting: PropTypes.bool,
	submitForm: PropTypes.func,
	preparationFile: PropTypes.func,
	editId: PropTypes.any,
	intl: PropTypes.func,
	can: PropTypes.func,
	loadAdminsLookup: PropTypes.func
};

export default reduxForm({
	form: 'payoutSystemsForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-systems/components/form.js